import React from 'react';
import Styles from './PopoverMenu.scss';

interface IPopoverMenuItemProps {
    text: string;
    onClick: (e) => void;
    parentRef: React.RefObject<any>;
    id: string;
    key?: number;
}

const PopoverMenuItem = (props: IPopoverMenuItemProps) => {
    const { text, onClick, parentRef, id, key } = props;

    const handleClick = (e) => {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }

        onClick(e);
        parentRef.current.closeMenu();
    };

    return (
        <button
            key={key ? key : 0}
            id={id}
            className={Styles.popoverMenuItemBtn}
            onClick={handleClick}
        >
            {text}
        </button>
    );
};

export default PopoverMenuItem;
